import { render } from "./LKFButton.vue?vue&type=template&id=3f77622f&ts=true"
import script from "./LKFButton.vue?vue&type=script&lang=ts"
export * from "./LKFButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__